import { useQuery } from "@tanstack/react-query";
import { ActionsTable, optionsDualBox } from "Common/Components";
import React, { useMemo, useState } from "react";
import { DeleteDepartament, FetchDepartament, FetchEmployes } from "services";
import { useEmployeStore } from "../../store";
import { Departament, Employe } from "interfaces";
import { NotificationType, showNotifications } from "helpers/toas_notification";
import { useTranslation } from "react-i18next";
import { useSessionStore } from "Common/Stores";

export const useEmployeList = () => {
  const { setDepartament, setIsEdit, setIsOpenModal, isOpenModal } =
  useEmployeStore();
  const [modalDelete, setModalDelete] = useState<boolean>(false);
  const [departamentId, setDepartamentId] = useState<number>(0);
  const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
  const { t } = useTranslation();

  const [branchSelected, setBranchSelected] = useState<string>("");

  const [filterStatus, setFilterStatus] = useState<optionsDualBox>({
    label: t("createEmploye.status.all"),
    value: " ",
  });

  const { session } = useSessionStore();


  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "index",
        cell: (cell: any) => cell.row.index + 1,
        enableColumnFilter: false,
      },
      {
        header: t("createEmploye.tablesColumn.name"),
        accessorKey: "names",
        enableColumnFilter: false,
      },
      {
        header: t("createEmploye.tablesColumn.phonenumber"),
        accessorKey: "phonenumber",
        enableColumnFilter: false,
      },
      {
        header: t("createEmploye.tablesColumn.branchName"),
        accessorKey: "branch.description",
        enableColumnFilter: false,
      },
      {
        header: t("departament.table.columns.actions"),
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => {
          const rowData = cell.row.original;
          return (
            <ActionsTable
              onClickEdith={() => {
                handleEdit(rowData);
              }}
              onClickDelete={() => {
                handleDelete(rowData);
              }}
            />
          );
        },
      },
    ],
    []
  );

  const handleDelete = (data: Employe) => {
    setDepartamentId(data.id);
    setModalDelete(true);
  };
  const handleEdit = (data: Employe) => {
    setIsEdit(true);
    setIsOpenModal(true);
    setDepartament(data);
  };

  const { data: departamentList, refetch: refetchDepartament } = useQuery({
    queryKey: ["departament", filterStatus.value || null],
    queryFn: () => {
      
      const state = (filterStatus.value === " " || filterStatus.value === "" || isNaN(Number(filterStatus.value))) ? null : parseInt(filterStatus.value, 10);
      return FetchEmployes(state);
    },
  });
  

  const deleteDepartament = async () => {
    try {
      setIsSubmiting(true)
      if (departamentId === 0) return;

      const response = await DeleteDepartament(departamentId);

      if (response.code === "200") {
        setModalDelete(false);
        refetchDepartament();
        showNotifications(
          NotificationType.SUCCESS,
          t("deleteModal.succedDelete")
        );
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("deleteModal.errorDelete" + response.message)
        );
      }
    } catch (error) {
      showNotifications(NotificationType.ERROR, t("deleteModal.errorDelete"));
    }finally{
      setIsSubmiting(false)
    }
  };

  return {
    columns,
    departament: departamentList?.data,
    refetchDepartament,
    modalDelete,
    setModalDelete,
    deleteDepartament,
    setIsOpenModal,
    isOpenModal,
    setDepartament,
    t,
    isSubmiting,
    setBranchSelected,
    setFilterStatus,
    filterStatus,
    session
  };
};
